import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

const { getMainServer } = httpApi.inquiry;

interface PageSize {
  size: number;
  page: number;
}

// 区服查询
interface GetMainServerParams extends PageSize {
  game_id: string;
  main_serverid: string;
  server_name: string;
}
export const apiGetMainServer = (json: GetMainServerParams): any =>
  http.httpPost({
    url: getMainServer,
    json,
  });
